import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const milestoneAddEditRBAC = {
  pageID: '5969aba2cecf229542298e448e27ef69',
  elementID: {
    ViewMilestone: 'ba366b52e5d6daf762d8b1da00b8e7a7',
    SaveMilestone: 'd3f1f71c126e21015d8894807cedbbe0',
  },
} as const

export const useMilestoneAddEditRBACPage = createUseRBAC(milestoneAddEditRBAC.elementID)

export type UseMilestoneAddEditRBACPageType = ReturnType<typeof useMilestoneAddEditRBACPage>
